import { render, staticRenderFns } from "./DConfirmationPopup.vue?vue&type=template&id=53e05892&scoped=true&"
import script from "./DConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./DConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./DConfirmationPopup.vue?vue&type=style&index=0&id=53e05892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e05892",
  null
  
)

export default component.exports